import { useEffect } from 'react'
import { averageScore, formatScore } from '../gameslib/score'
import { sfxClick, sfxNext, sfxScore } from '../gameslib/audio'
import { ArrowIcon } from './IntroScreen'

export function RoundResult({
  score,
  round,
  totalRounds,
  children,
  onNext,
  nextButtonRef,
  scoreColor = '#000',
  layout = 'split',
}) {
  const [int, dec] = formatScore(score).split('.')

  useEffect(() => {
    void sfxScore(score)
  }, [score])

  return (
    <div className={layout === 'split' ? 'round-result' : 'round-result round-result--stack'}>
      <div className="round-result__content">{children}</div>
      <div className="round-pill" style={{ color: scoreColor, opacity: 0.6 }}>
        {round} / {totalRounds}
      </div>
      <div className="round-result__score" style={{ color: scoreColor }}>
        <span>{int}</span>
        <span className="dot">.</span>
        <span>{dec}</span>
        <span className="round-result__pct">%</span>
      </div>
      <button
        type="button"
        ref={nextButtonRef}
        className="go-btn"
        aria-label="Next round"
        onClick={() => {
          void sfxNext()
          onNext()
        }}
      >
        <ArrowIcon />
      </button>
    </div>
  )
}

export function TotalScreen({ scores, onReplay }) {
  const avg = averageScore(scores)

  useEffect(() => {
    void sfxScore(avg)
  }, [avg])

  return (
    <div className="total-screen">
      <p className="total-screen__eyebrow">Final score</p>
      <h2 className="total-screen__score">
        {avg.toFixed(2)}
        <span>%</span>
      </h2>
      <ul className="total-screen__rounds">
        {scores.map((s, i) => (
          <li key={i}>
            Round {i + 1}: <strong style={{ color: '#fff' }}>{s.toFixed(2)}%</strong>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="primary-btn"
        onClick={() => {
          void sfxClick()
          onReplay()
        }}
      >
        Play again
      </button>
    </div>
  )
}
